export function getMembersLimit(organization) {
  return organization ? 50 : 0;
}
